module.exports = __webpack_public_path__ + "img/avatar2.838fd445.jpg";